import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import { useQuery } from "@tanstack/react-query";
import GatewayService from "../services/GatewayService";
import { PersonAttr } from "../components/routeComponents/Persons/Person";

function useGetPerson(personId: string) {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery<PersonAttr>({
    queryKey: ["person", personId],
    queryFn: () => GatewayService.getPerson(personId),
    retry: false,
    enabled: !!personId,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    person: result.data,
  };
}

export { useGetPerson };
